import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
declare let $: any;
declare let Swal: any;

@Component({
    selector : 'favorite-room-screen',
    templateUrl:'favorite-room-screen.html'
})
export class FavoriteRoomScreenComponent implements OnInit, OnDestroy{

  public admin=false;
  public list;
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.list=[];
    this._companyService.getUserFavoriteRooms(this._appData.instagramUser).get().then(snap=>{
      snap.forEach( rSnap =>{
        let room=rSnap.data();
        this.list.push(room)
      })
    })

  }
  public saveToList(){
    let room=this._appData.room;
    if (!room){
      this._companyService.getRoom(this._appData.room.id).get().then(val=>{
        room=val.data();
        let hasIt=this.list.filter((r)=>{
          return r.id==room.id;
        })
        if (hasIt.length>0){
          Swal.fire({title:this.translate.instant('FAVORITE_ROOM_SCREEN_6'),text:this.translate.instant('FAVORITE_ROOM_SCREEN_7')})
        }
        else{
          room.roomName=room.roomName.toUpperCase()
          this._companyService.getUserFavoriteRooms(this._appData.instagramUser).doc(room.id).set(room)
          this.list.push(room)
      
        }
  
      })
    }
    else{
      let hasIt=this.list.filter((r)=>{
        return r.id==room.id;
      })
      if (hasIt.length>0){
        Swal.fire({title:this.translate.instant('FAVORITE_ROOM_SCREEN_6'),text:this.translate.instant('FAVORITE_ROOM_SCREEN_7')})
      }
      else{
        room.roomName=room.roomName.toUpperCase()
        this._companyService.getUserFavoriteRooms(this._appData.instagramUser).doc(room.id).set(room)
        this.list.push(room)
    
      }
  
    }

  }
  public doSearch(event: any){
    let input=$("#roomsearchInput").val();
    this.list=[];
    let upper=input.toUpperCase();
    this._companyService.getUserFavoriteRooms(this._appData.instagramUser).where("roomName", ">=", upper).get().then(snap=>{
      snap.forEach( rSnap =>{
        let room=rSnap.data();
        this.list.push(room)
      })
    })

  }

  public ngOnDestroy() : any {
  }

  public goto(roomToGo){
    let room=this._appData.room;
    
    if (room.id==roomToGo.id){
      Swal.fire({title:this.translate.instant('FAVORITE_ROOM_SCREEN_8'),text:this.translate.instant('FAVORITE_ROOM_SCREEN_9')})
    }
    else{
      
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
        text:this.translate.instant('FAVORITE_ROOM_SCREEN_10'),
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCancelButton: true,     
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.gotoRoom(roomToGo);
        }
      });       
    }
  }
  public delete(room){
    Swal.fire({
      title:this.translate.instant('FAVORITE_ROOM_SCREEN_11'),
      text:this.translate.instant('FAVORITE_ROOM_SCREEN_12'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.getUserFavoriteRooms(this._appData.instagramUser).doc(room.id).delete();

        for (let i=0;i<this.list.length;i++){
          if (this.list[i].id==room.id){
            this.list.splice(i,1)
          }
        }
      }
    });       

  }
  public edit(room){
    Swal.fire({
      title:this.translate.instant('FAVORITE_ROOM_SCREEN_13'),
      text:this.translate.instant('FAVORITE_ROOM_SCREEN_14'),
      input: 'text',
      inputAttributes: {
      autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('SAVE'),
      showLoaderOnConfirm: true,
    }).then((result) => {
        if (result.dismiss=='backdrop') {}
        else if (result.dismiss=='close') {}
        else if (result.dismiss=='cancel'){}
        else if (result.value) {
          let name=result.value
          room.roomName=name.toUpperCase();
          this._companyService.getUserFavoriteRooms(this._appData.instagramUser).doc(room.id).set(room);
          for (let i=0;i<this.list.length;i++){
            if (this.list[i].id==room.id){
              this.list[i]=room;
            }
          }
        }
      })
  }
  public gotoRoom(room){
    let roomToGo=room.id
      if (!this._appData.instagramUser){
        $('#registerSocialModal').modal("show"); 
        this._appData.tiping=true;
        return
      }
      this._companyService.getUserRoomPosition(roomToGo).get().then((snap)=>{
        let tusers=0;
        snap.forEach(userOnRoom=>{
          let us=userOnRoom.data(); //objects correspond to users;
          if (us){
            tusers++
          }
        })
        if (tusers>=65){
          Swal.fire({
            title:this.translate.instant('FAVORITE_ROOM_SCREEN_15'),
            text:this.translate.instant('FAVORITE_ROOM_SCREEN_16'),
            });

        }
        else{
          let date=new Date();
          let time=date.getTime();
          let swalObj={
            title: room.roomName,
            text:this.translate.instant('FAVORITE_ROOM_SCREEN_17')+tusers+this.translate.instant('FAVORITE_ROOM_SCREEN_18'),
            showCloseButton: true,
            confirmButtonText: this.translate.instant('ENTER')
            }
          Swal.fire(swalObj).then((result) =>{
            if (result.value) {     
              let domain=window.location.origin
              window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+roomToGo;
            }
          })
        }

      });
  }
  public seeProfile(room){
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/favorite-room-screen/favorite-room-screen.ts